<template>
    <div class="report-mb template4">
        <div v-show="showMarketReportData || showMarketComing">
            <div class="board_container">
                <!-- card  the list  start -->
                <div class="board">
                    <Swiper v-bind="options" class="slide_container">
                        <Slide>
                            <board-card
                                :params="soldListing"
                                :hasRecentSold="hasRecentSold"
                            />
                        </Slide>
                        <Slide>
                            <board-card
                                :params="avgSalePrice"
                                :hasRecentSold="hasRecentSold"
                            />
                        </Slide>
                        <Slide>
                            <board-card
                                :params="avgDaysOnMarket"
                                :hasRecentSold="hasRecentSold"
                            />
                        </Slide>
                    </Swiper>
                </div>
                <!-- card  the list  end -->
                <div
                    class="loading_container"
                    v-show="showMarketReportLoading || showMarketComing"
                >
                    <Loading />
                </div>
            </div>
        </div>
        <div class="location_tips_container" v-show="showMarketNoLocation">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v4-img-no-market@2x.png"
                :alt="$t('md-snapshot-search.pleaseInputAValid')"
            />
            <div class="desc">
                {{ $t('md-snapshot-search.pleaseInputAValid') }}
            </div>
        </div>
        <div class="no_data" v-show="showMarketNoData">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v4-img-no-market@2x.png"
                :alt="noDataText"
            />
            <div class="desc">
                {{ noDataText }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import BoardCard from '../board-card';
import Loading from '../../../../../components/loading';
import MoreBtnCommon from '../../../_mixins/more-btn/common';
import { Swiper, SwiperSlide } from '@/common/swiper';

export default {
    name: 'SnapshotMb',
    components: {
        'board-card': BoardCard,
        Swiper,
        Slide: SwiperSlide,
        Loading
    },
    mixins: [MoreBtnCommon],
    props: {
        soldListing: {
            required: true
        },
        avgSalePrice: {
            required: true
        },
        avgDaysOnMarket: {
            required: true
        }
    },
    data: function() {
        return {
            options: {
                slidesPerView: 'auto',
                ssrSlidesPerView: 1,
                spaceBetween: 14
            }
        };
    },
    computed: {
        ...mapState({
            'showMarketReportData': 'showMarketReportData',
            'showMarketReportLoading': 'showMarketReportLoading',
            'showMarketNoLocation': 'showMarketNoLocation',
            'showMarketComing': 'showMarketComing',
            'showMarketNoData': 'showMarketNoData'
        }),
        hasRecentSold() {
            return this.soldListing?.status !== 3;
        }
        // container  style of
        // containerStyle() {
        //     return { height: `${this.needMore ? 288 : 202}px` };
        // }
    }
};
</script>

<style lang="scss">
.report-mb.template4 {
    /*  Layout related  start */

    .board_container {
        width: 100%;
        padding-left: 20px;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        .loading_container {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: var(--level-low);
            background: rgba(255, 255, 255, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    /*  Layout related  end */
    .more_container {
        padding: 0 20px;
        .more {
            margin-top: 40px;
            width: 100%;
            height: 40px;
            border-radius: 2px;
            background-color: var(--color-theme);
            font-size: 16px;
            font-weight: 600;
            color: #ffffff;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    .coming_container,
    .location_tips_container,
    .no_data {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 220px;
            height: 130px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
    .slide_container {
        display: flex;
    }
    .swiper-slide {
        width: 80vw;
        &:last-child {
            margin-right: 20px;
        }
    }
    .more {
        p {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
